//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Winters',
  data() {
    return {
      form: {
        item1: '',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          console.log(form, 'form');
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let result
        let num1 = 1.5 * form.item1 + 8 - 2
        let num2 = 1.5 * form.item1 + 8 + 2
        result = String(num1.toFixed(0)) + ' - ' + String(num2.toFixed(0))
        self.hasScore = true
        return String(result)
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/Winters.vue